module.exports = __webpack_public_path__ + "img/little_lemur_256.358a3090.png";